
export const environment = {
  production: false,
  apiUrl: "https://api.staging.solvpath.com",
  cbApiUrl: "https://cb.staging.solvpath.com",
  cbDocsUrl: "",
  checkoutTemplatesUrl: "https://templates.staging.solvpath.com",
  stripePublicKey: "pk_test_51Hr7vYDWscBUSafciSlE7jpfec9PodfZX9urmtSRlhnzIWp11SAgnDrAKmCswNM3IMbbgpwZhHzwF0DIms5USfy000LcqS7XJk",
  stripeGatewayPublicKey: "pk_test_51SVFmpRdyiHSjpy3qg0HwfhWwbABFvXUhVBLjDOQQPxr9KYTPN2mwRocWK9SdPkvqJlhnstfvsCehTJ99WDcSbJe00m2sqKqdj",
  captchaKey: "6Ld1eFIUAAAAALdEKdKIM0c5ejB_d2py9fuKunxB",
  sentryDsn: "https://88f81f5ff36e4fe5979710df8c610f2b@o338987.ingest.us.sentry.io/5599513",
  sentryDebugMode: false,
  emailDomain: "",
  googleClientId: "966269019386-8mu03k50hgvp085ekb9f0d9peak1mlsc.apps.googleusercontent.com",
  emailApiUrl: "https://emails.staging.solvpath.com",
  mouseflowId: " ",
  intercomAppId: "mlohh38y",
  askSolvpathApiUrl: "https://report-chatbot.staging.solvpath.com",
  ompPreviewUrl: "https://{subdomain}.react.staging.solvpath.com",
  pusher: {
    key: "5f58037267cd751d3b32",
    cluster: "us2",
    channel: "solvpath-staging",
  }
};
